import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "utils/api";

// estimation quotation
export const updateRebateDate = createAsyncThunk(
  'rebate-date-settings',
  async ({ value, bodyParams }, thunkAPI) => {
    try {
      const response = await API.put(`/${value}`, bodyParams);
      return response
    }
    catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  })
